module.exports = __webpack_public_path__ + "static/media/turquoise.163d0db6.png";